import * as moment from "moment";

export const DEFAULT_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export class TimeRange {
  public from: string;
  public to: string;
  public previousFrom: string;
  public previousTo: string;
  public interval: {
    value: number;
    type: any;
    longName: string;
    inDays: number;
  };

  // Wether time returned needs to be calculated just in time keepeing the inital interval
  dynamic = false;

  constructor(value: number | string, type: string, dynamic?: boolean) {
    if (dynamic) {
      this.dynamic = true;
    }
    if (typeof value === "string") {
      this.updateCustomInterval(value, type);
    } else {
      this.updateInterval(value, type);
    }
  }

  updateInterval(value: number, type: any) {
    this.from = moment().subtract(value, type).format(DEFAULT_TIME_FORMAT);
    this.to = moment().format(DEFAULT_TIME_FORMAT);
    this.previousFrom = moment(this.from)
      .subtract(value, type)
      .format(DEFAULT_TIME_FORMAT);
    this.previousTo = this.from;
    this.interval = this.intervalInDays(value, type);
  }

  updateCustomInterval(from: any, to: any) {
    let dif: number;

    if (from == to) {
      this.from = from + " 00:00:00";
      this.to = to + " 23:59:59";
      dif = 86400;
      this.previousFrom =
        this.from.substring(0, 8) +
        (parseInt(this.from.split("-")[2]) - 1).toString() +
        " 00:00:00";
    } else {
      this.from = moment(from).format(DEFAULT_TIME_FORMAT);
      this.to = moment(to).format(DEFAULT_TIME_FORMAT);
      dif = moment(to).diff(moment(from), "seconds");
      this.previousFrom = moment(this.from)
        .subtract(dif, "seconds")
        .format(DEFAULT_TIME_FORMAT);
    }

    this.previousTo = this.from;
    this.interval = {
      type: "seconds",
      value: dif,
      longName: "seconds",
      inDays: null,
    };
  }

  intervalInDays(value, type) {
    let interval;
    switch (type) {
      case "d":
        interval = {
          value: value,
          type: type,
          longName: moment.normalizeUnits(type),
          inDays: value == 1 ? 7 : 30,
        };
        break;
      case "w":
        interval = {
          value: value,
          type: type,
          longName: moment.normalizeUnits(type),
          inDays: 7,
        };
        break;
      case "h":
        interval = {
          value: value,
          type: type,
          longName: moment.normalizeUnits(type),
          inDays: 7,
        };
        break;
      case "M":
        interval = {
          value: value,
          type: type,
          longName: moment.normalizeUnits(type),
          inDays: 30,
        };
        break;
      case "Y":
        interval = {
          value: value,
          type: type,
          longName: moment.normalizeUnits(type),
          inDays: 365,
        };
        break;
      default:
        30;
        break;
    }
    return interval;
  }

  // getTimezoneValue(timeZone: string, trim?: boolean) {
  //   // Keeps interval and return current values based on current time
  //   if (this.dynamic) {
  //     const now = moment().tz(timeZone);
  //     let from = moment().tz(timeZone).subtract(this.interval.value, this.interval.type);
  //     if (trim) {
  //       const max = moment(this.to).subtract(24, 'hours');
  //       from = from < max ? max : from;
  //     }
  //     return {
  //       to: now,
  //       from: from
  //     };
  //   } else {
  //     const max = moment.tz(timeZone).subtract(24, 'hours');
  //     let from = moment(this.from).tz(timeZone);
  //     let to = moment.tz(timeZone);
  //     console.log(max.format(), from.format(), to.format());
  //     if (trim) {
  //       from = from < max ? max : from;
  //       to = to < max ? max : to;
  //     }
  //     return {
  //       from: from,
  //       to: to
  //     };
  //   }
  // }

  getLDSTime(timeZone: string) {
    let tzTo = moment(this.nowToTimezone(timeZone)).format();
    let max = moment(tzTo).subtract(1, "days").format();
    let tzFrom = moment(tzTo)
      .subtract(this.interval.value, this.interval.type)
      .format();
    tzFrom = tzFrom < max ? max : tzFrom;
    return {
      to: moment(tzTo),
      from: moment(tzFrom),
    };
  }

  getStarmsTime(timeZone: string) {
    return {
      from: this.toTimezone(this.from, timeZone),
      to: this.toTimezone(this.to, timeZone),
    };
  }

  toTimezone(date, tzString) {
    return new Date(
      (typeof date === "string" ? new Date(date) : date).toLocaleString(
        "en-US",
        { timeZone: tzString }
      )
    );
  }

  nowToTimezone(tzString) {
    return new Date(
      new Date().toLocaleString("en-US", { timeZone: tzString })
    ).getTime();
  }
  // getValue(trim?: boolean) {
  //   // Keeps interval and return current values based on current time
  //   if (this.dynamic) {
  //     const now = moment();
  //     let from = moment().subtract(this.interval.value, this.interval.type);
  //     if (trim) {
  //       const max = now.clone().subtract(24, 'hours');
  //       from = from < max ? max : from;
  //     }

  //     let val ={
  //       to: now,
  //       from:  from
  //     };
  //     return val;

  //   } else {
  //     const max = moment().subtract(24, 'hours');
  //     let from = moment(this.from);
  //     let to = moment(this.to);
  //     if (trim) {
  //       from = from < max ? max : from;
  //       to = to < max ? max : to;
  //     }

  //     let val = {
  //       from: from,
  //       to: to
  //     };
  //     console.log('valval', val);
  //     return val;
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/models/trend-live-models/TimeRange.ts